import preact from 'preact'
import Downshift from 'downshift/preact'

import HitContainerControl from './HitContainerControl'
import { SearchBox } from './SearchBox'

class AlgoliaSearchForControl extends preact.Component {
  render ({ refine, hits, searchResults, updateSearch, callback, exclude, placeholder, searchById, finalInput }) {
    return (
      <Downshift
        itemToString={i => (i ? i.title : i)}
        onChange={(item, root) => {
          if (item !== null) {
            callback(item)
            root.clearSelection()
          }
        }}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          setHighlightedIndex,
          closeMenu,
          openMenu,
          inputValue,
          reset,
          isOpen
        }) => <div className='algolia-search-container'>
          <SearchBox isControl placeholder={placeholder} reset={reset} refine={refine} updateSearch={updateSearch} setHighlightedIndex={setHighlightedIndex} inputValue={inputValue}
            getInputProps={getInputProps} openMenu={openMenu} isOpen={isOpen} key='search' />

          {
            inputValue && isOpen
              ? <HitContainerControl
                key='hits-container'
                searchResults={searchResults}
                inputValue={inputValue}
                hits={hits} highlightedIndex={highlightedIndex}
                callback={callback}
                getItemProps={getItemProps}
                searchById={searchById}
                finalInput={finalInput}
                exclude={exclude} />
              : null
          }
        </div>
        }
      </Downshift>
    )
  }
}

export default AlgoliaSearchForControl
